module.exports = __webpack_public_path__ + "static/media/booking-preview.f3962660.jpg";